/**
 * Date-extensions locale Uzbek [uz]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('uz', {
    monthNames: ['январ','феврал','март','апрел','май','июн','июл','август','сентябр','октябр','ноябр','декабр'],
    monthShortNames: ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек'],
    dayNames: ['Якшанба','Душанба','Сешанба','Чоршанба','Пайшанба','Жума','Шанба'],
    dayShortNames: ['Якш','Душ','Сеш','Чор','Пай','Жум','Шан']
});
